module.exports = __webpack_public_path__ + "img/hockey.55c1757a.jpg";